export default "__VITE_ASSET__D8eTg57N__"